module.exports = {
    label: {
        header: 'GLP-1 History',
        comparison: 'Progress comparison',
        visits: 'Visits',
        measure: 'Measure',
        thisRequest: 'Current request',
        initialApplication: 'Initial application',
        noApplication: 'No GLP-1 application found for this patient.',
        noFollowUps: 'No follow-ups yet.',
        nodata: '----',
        error: 'Could not load the GLP-1 history.',
        buttons: {
            back: 'Back to request',
        }
    }
}
